import lodash from 'lodash'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

type TInlineEditorInvalidProps = {}

const InlineEditorInvalid = (
  props: TInlineEditorInvalidProps,
): React.ReactElement => {
  const {} = props

  return (
    <span className="text-danger">
      {i18n.t('inline_editor_invalid', 'Ungültig')}
    </span>
  )
}

export default InlineEditorInvalid
